import React from 'react';

export enum Severity {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  USER_ERROR = 'user_error',
}

type SvgBaseProps = {
  severity: Severity;
};

const SvgBase: React.FC<SvgBaseProps> = ({ severity, children }) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" aria-labelledby="title" role="img">
    <title id="title" lang="en">{`${severity} alert`}</title>
    {children}
  </svg>
);

export const AlertIcon: React.VFC<SvgBaseProps> = ({ severity }) => {
  if (severity === Severity.WARNING) {
    return (
      <SvgBase severity={severity}>
        <circle cx="20" cy="20" r="17" fill="#FEAE22" />
        <path
          d="M21.6958 11.0923L21.4174 23.3168H18.7345L18.4308 11.0923H21.6958ZM18.5574 26.0756C18.9286 25.7044 19.4095 25.5188 20 25.5188C20.5906 25.5188 21.063 25.7044 21.4174 26.0756C21.7886 26.4299 21.9742 26.8939 21.9742 27.4676C21.9742 28.0244 21.7886 28.48 21.4174 28.8343C21.063 29.1887 20.5906 29.3658 20 29.3658C19.4095 29.3658 18.9286 29.1887 18.5574 28.8343C18.203 28.48 18.0259 28.0244 18.0259 27.4676C18.0259 26.8939 18.203 26.4299 18.5574 26.0756Z"
          fill="white"
        />
      </SvgBase>
    );
  }

  if (severity === Severity.INFO) {
    return (
      <SvgBase severity={severity}>
        <circle opacity="0.1" cx="20" cy="20" r="17" fill="#427783" />
        <path
          d="M22.0251 12.6363C22.0251 13.21 21.8311 13.6825 21.443 14.0537C21.0549 14.4249 20.574 14.6105 20.0004 14.6105C19.4267 14.6105 18.9458 14.4249 18.5577 14.0537C18.1696 13.6825 17.9756 13.21 17.9756 12.6363C17.9756 12.0795 18.1696 11.6155 18.5577 11.2443C18.9458 10.8731 19.4267 10.6875 20.0004 10.6875C20.574 10.6875 21.0549 10.8731 21.443 11.2443C21.8311 11.6155 22.0251 12.0795 22.0251 12.6363ZM18.4312 29.0623V16.6606H21.5189V29.0623H18.4312Z"
          fill="#427783"
        />
      </SvgBase>
    );
  }

  if (severity === Severity.USER_ERROR) {
    return (
      <SvgBase severity={severity}>
        <rect opacity="0.1" width="40" height="40" rx="20" fill="#EA544A" />
        <path
          d="M28.71 12.71L27.29 11.29L20 18.59L12.71 11.29L11.29 12.71L18.59 20L11.29 27.29L12.71 28.71L20 21.41L27.29 28.71L28.71 27.29L21.41 20L28.71 12.71Z"
          fill="#EA544A"
        />
      </SvgBase>
    );
  }

  return (
    <SvgBase severity={Severity.ERROR}>
      <path
        d="M18.2697 3.98473C19.0403 2.65548 20.9597 2.65548 21.7303 3.98473L38.2591 32.4969C39.032 33.8303 38.07 35.5 36.5288 35.5H3.47118C1.93001 35.5 0.96796 33.8303 1.74091 32.4969L18.2697 3.98473Z"
        fill="#EA544A"
      />
      <path
        d="M21.6958 13.0923L21.4174 25.3168H18.7345L18.4308 13.0923H21.6958ZM18.5574 28.0756C18.9286 27.7044 19.4095 27.5188 20 27.5188C20.5906 27.5188 21.063 27.7044 21.4174 28.0756C21.7886 28.4299 21.9742 28.8939 21.9742 29.4676C21.9742 30.0244 21.7886 30.48 21.4174 30.8343C21.063 31.1887 20.5906 31.3658 20 31.3658C19.4095 31.3658 18.9286 31.1887 18.5574 30.8343C18.203 30.48 18.0259 30.0244 18.0259 29.4676C18.0259 28.8939 18.203 28.4299 18.5574 28.0756Z"
        fill="white"
      />
    </SvgBase>
  );
};
